module.exports = __webpack_public_path__ + "static/media/dashboard.260b65e4.svg";